export enum UI_ELEMENTS {
  CONTEXT_MENU,
  SNACKBAR,
  DELETE_CONFIRMATION,
  CANCEL_CONFIRMATION,
  DEACTIVATE_CONFIRMATION,
  ACTIVATE_CONFIRMATION,
  RESET_CONFIRMATION,
  SAVE_CONFIRMATION,
  EXPANDED_LIST,
  INVALID_CONFIRMATION,
  VALID_CONFIRMATION,
  LIMIT_EXCEEDED_CONFIRMATION,
}
